import axios from "axios";
import { getUserAuth } from "../helpers";

export const api = axios.create({
  baseURL: process.env["REACT_APP_SERVER_URL"],
});

let isAlert = false;

const logoutUser = () => {
  localStorage.clear();
  isAlert = true;

  window.alert(
    "Attention: Your session has expired. Please log in again to continue accessing the system. Thank you!",
  );
  window.location.href = "/auth/login";
};

api.interceptors.request.use((config) => {
  const accessToken = getUserAuth();

  if (accessToken && config.headers) {
    config.headers["auth-Token"] = `${accessToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!isAlert) {
        logoutUser();
      }
      // const accessTokenExpiresAt = localStorage.getItem('accessTokenExpiresAt');
      // const currentTime = new Date().getTime() / 1000; // Convert to seconds

      // if (currentTime > accessTokenExpiresAt) {
      //   // Access token has expired, trigger logout
      //   logoutUser();
      // }
    }

    return Promise.reject(error);
  },
);
